import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkIfTicketHasSmsChannel } from 'services/smsConversations';
import { ICheckIfTicketHasChannelResponse } from 'services/smsConversations/types';

interface IProps {
  crmId: number;
  ticketId: number | string;
}

export const ThunkCheckIfTicketHasSmsChannel = createAsyncThunk<
  ICheckIfTicketHasChannelResponse,
  IProps
>('pod/checkIfTicketHasSmsChannel', async payload => {
  const r = await checkIfTicketHasSmsChannel(payload);
  return r.data;
});
